import { Component, OnInit, Input, HostBinding, ViewChild, ElementRef } from '@angular/core';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { resolveThemeCssClass } from '../lib/helper/panel-settings';
import { IPictureData } from '../lib/public_api';
import { IRteStyleSettings } from '../../shared/interface/rte-style-settings';
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';

interface ILinkProperty {
  url: string;
  target: string;
}
interface ImagePanelData {
  image: IUProperty<IPictureData>;
  link?: IUProperty<ILinkProperty>;
  description?: IUProperty<string>;
  showFullSize: IUProperty<boolean>;
  
  rteStyleSettings?: IRteStyleSettings;
  panelSettings?: any;
  anchor: IUProperty<string>
}
@Component({
  selector: 'app-image-panel',
  templateUrl: './image-panel.component.html',
  styleUrls: ['./image-panel.component.less']
})
export class ImagePanelComponent implements OnInit {
  @Input() data: ImagePanelData;
  @HostBinding('class') get hostClasses() { return resolveThemeCssClass(this.data.panelSettings) }
  @ViewChild('descriptionEl', { static: false }) descriptionEl: ElementRef<HTMLElement>;

  showFullSize: boolean;

  ngOnInit() {
    this.showFullSize = this.data.showFullSize.value;

    if (!this.showFullSize) this.data.image.value.sources = [];
  }
  ngAfterViewInit(): void {
    applyRteSettings(this.data, this.descriptionEl);
  }
}
